import { WppSkeleton } from '@wppopen/components-library-react'
import AsyncTypography from 'components/AsyncTypography/AsyncTypography'
import styles from './skeletonStyles.module.scss'

const InputSkeleton = () => {
  return (
    <div className={styles.inputSkeleton__container}>
      <AsyncTypography type="l-strong" tag="span" isLoading />
      <WppSkeleton variant="rectangle" height={40} className={styles.inputSkeleton} data-testid="input-skeleton" />
    </div>
  )
}

export default InputSkeleton
